<template>
  <v-col cols="12" md="3" sm="12">
    <v-card :loading="loading" class="mx-auto dashboard-card" elevation="4" height="200">
      <v-card-text class="card-header">
        <v-icon class="mr-2" color="primary">mdi-account-group</v-icon>
        <span class="text-h6 font-weight-medium">Raça/Cor</span>
      </v-card-text>

      <div class="content-flex">
        <!-- Gráfico no lado esquerdo (menor) -->
        <div style="flex: 0.7; height: 100%; position: relative; margin-top: 5px">
          <apexchart height="55%" width="100%" :options="chartOptions" :series="series" />
        </div>

        <!-- Legendas no lado direito (maior) -->
        <div style="flex: 1; padding: 14px; overflow-y: auto; height: 100px">
          <div class="legend-container">
            <div
              v-for="(label, index) in chartOptions.labels"
              :key="index"
              class="legend-item"
              v-show="series[index] > 0"
            >
              <span class="legend-color" :style="{ backgroundColor: colors[index] }"></span>
              <span class="legend-text">{{ label }}: {{ series[index] }} </span>
            </div>
          </div>
        </div>
      </div>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: "RacaCorCard",
  props: {
    franquiaId: {
      type: Number,
      default: null,
    },
  },
  mounted() {
    this.getRacaCor();
  },
  watch: {
    franquiaId() {
      this.getRacaCor();
    },
  },
  data() {
    return {
      loading: true,
      series: [],
      // Cores com melhor visibilidade: Branca, Preta, Parda, Amarela, Indígena, Não Declarada, Não Informada
      colors: ["#E8D5B7", "#2C1810", "#D4A373", "#FFC107", "#CD853F", "#78909C", "#B0BEC5"],
      chartOptions: {
        chart: {
          type: "donut",
        },
        colors: [],
        legend: {
          show: false,
        },
        labels: [],
        dataLabels: {
          enabled: false,
        },
        plotOptions: {
          pie: {
            donut: {
              size: "55%",
            },
          },
        },
        tooltip: {
          enabled: true,
          custom({ series, seriesIndex, dataPointIndex, w }) {
            const value = series[seriesIndex];
            const total = series.reduce((a, b) => a + b, 0);
            const percentage = ((value / total) * 100).toFixed(1);
            const label = w.globals.labels[seriesIndex];
            const valueFormatted = value.toLocaleString("pt-BR");

            return `<div style="padding: 10px; background: #fff; border: 1px solid #e0e0e0; border-radius: 6px; box-shadow: 0 2px 8px rgba(0,0,0,0.15);">
              <strong style="color: #424242;">${label}: ${percentage}%</strong><br/>
              <span style="color: #757575; font-size: 0.9em;">(${valueFormatted} alunos)</span>
            </div>`;
          },
        },
      },
    };
  },
  computed: {
    totalAlunos() {
      return this.series.reduce((a, b) => a + b, 0);
    },
  },
  methods: {
    getPercentage(value) {
      if (this.totalAlunos === 0) return 0;
      return ((value / this.totalAlunos) * 100).toFixed(1);
    },
    async getRacaCor() {
      this.loading = true;
      try {
        const response = await this.$services.alunosService.racaCor(this.franquiaId);
        const data = response.data;

        const labels = [
          "Branca",
          "Preta",
          "Parda",
          "Amarela",
          "Indígena",
          "Não Declarada",
          "Não informado",
        ];
        const seriesData = [
          parseInt(data.branca || 0, 10),
          parseInt(data.preta || 0, 10),
          parseInt(data.parda || 0, 10),
          parseInt(data.amarela || 0, 10),
          parseInt(data.indigena || 0, 10),
          parseInt(data.naoDeclarada || 0, 10),
          parseInt(data.naoInformado || 0, 10),
        ];

        this.series = seriesData;
        this.chartOptions = {
          ...this.chartOptions,
          labels,
          colors: this.colors,
        };
      } catch (error) {
        this.series = [0];
        this.chartOptions.labels = ["Erro"];
        this.chartOptions.colors = [this.colors[0]];
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.dashboard-card {
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
  border-top: 4px solid #fbbb14;
}

.dashboard-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1) !important;
}

.card-header {
  padding-bottom: 0;
  display: flex;
  align-items: center;
  background-color: #f8f9fa;
  border-bottom: 1px solid #eee;
}

.legend-container {
  margin-top: 10px;
  max-height: 100px;
  overflow-y: auto;
}

.legend-item {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}

.legend-color {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 3px;
  margin-right: 8px;
}

.legend-text {
  font-size: 0.8rem;
}

.content-flex {
  display: flex;
  height: 100%;
}

/* Ajustes responsivos */
@media (max-width: 600px) {
  div[style*="display: flex"] {
    flex-direction: column;
  }

  .legend-container {
    max-height: none;
  }
}
</style>
